import {ISyncStepStatus} from "../../index";

interface ICustomSyncStepStatus extends ISyncStepStatus {
    $ago: string
    $timestamp: number
}
